var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.733,
    cy: 19.4502,
    r: 18.75,
    fill: "#FDFDFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3178 8.9502H15.6352C12.0999 8.9502 9.23303 11.7957 9.23303 15.3046V22.93C9.23303 26.4389 12.0999 29.2844 15.6352 29.2844H23.3178C26.8531 29.2844 29.72 26.4389 29.72 22.93V15.3046C29.72 11.7957 26.8531 8.9502 23.3178 8.9502ZM27.7993 22.93C27.7993 25.3828 25.789 27.3781 23.3178 27.3781H15.6352C13.164 27.3781 11.1537 25.3828 11.1537 22.93V15.3046C11.1537 12.8518 13.164 10.8565 15.6352 10.8565H23.3178C25.789 10.8565 27.7993 12.8518 27.7993 15.3046V22.93Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4821 14.0371C16.6536 14.0371 14.3604 16.3133 14.3604 19.1207C14.3604 21.9281 16.6536 24.2042 19.4821 24.2042C22.3106 24.2042 24.6038 21.9281 24.6038 19.1207C24.6038 16.3133 22.3106 14.0371 19.4821 14.0371ZM19.4821 22.2979C17.7176 22.2979 16.281 20.872 16.281 19.1207C16.281 17.3681 17.7176 15.9434 19.4821 15.9434C21.2465 15.9434 22.6832 17.3681 22.6832 19.1207C22.6832 20.872 21.2465 22.2979 19.4821 22.2979Z",
    fill: "#121212"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.973 14.3406C25.3506 14.3406 25.6567 14.0366 25.6567 13.6615C25.6567 13.2865 25.3506 12.9824 24.973 12.9824C24.5955 12.9824 24.2894 13.2865 24.2894 13.6615C24.2894 14.0366 24.5955 14.3406 24.973 14.3406Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.09e5cf2de91f394e1a0b60dd718482b8.svg";
export { ForwardRef as ReactComponent };